import React, { useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Container, Input, Label } from "reactstrap"
import PageMetaTags from "components/PageMetaTags"

import { connect } from "react-redux"

import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { SaveButton } from "components/Buttons"
import { resend2FaCode, set2FaToken, validate2Fa } from "store/actions"
import { URL_PATHS } from "constants/index"

const Two_FA = ({
  TwoFaToken,
  set2FaToken,
  validate2Fa,
  loading,
  history,
  resend2FaCode,
}) => {
  const [codeValue, setCodeValue] = useState("")

  useEffect(() => {
    if (!TwoFaToken) {
      history?.push(URL_PATHS.LOGIN)
    }
    return () => {
      set2FaToken(null)
    }
  }, [])

  return (
    <React.Fragment>
      <PageMetaTags title={"Login"} />
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">2FA Verification</h5>
                        <p>
                          We've sent you a verification code on your email
                          address.
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <div className="avatar-md profile-user-wid mb-4">
                      <span className="avatar-title rounded-circle bg-light">
                        <img
                          src={logo}
                          alt=""
                          className="rounded-circle"
                          height="34"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="p-2">
                    <Row>
                      <Col>
                        <Label for="code">Code</Label>
                        <Input
                          value={codeValue}
                          onChange={event => setCodeValue(event?.target?.value)}
                          id="code"
                          className="form-control"
                          placeholder="Code"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3">
                      <Col>
                        <span
                          className="text-primary text-decoration-underline"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            resend2FaCode({ token: TwoFaToken })
                          }}
                        >
                          Resend Code
                        </span>
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-center mt-4">
                      <Col xs="auto">
                        <SaveButton
                          type="button"
                          content="Submit"
                          color="primary"
                          disabled={!codeValue}
                          onClick={() =>
                            validate2Fa(
                              {
                                code: codeValue,
                                token: TwoFaToken,
                              },
                              history
                            )
                          }
                          loading={loading}
                        />
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  TwoFaToken: state.Login.TwoFaToken,
  loading: state.Login.loading,
})

const mapDispatchToProps = dispatch => ({
  set2FaToken: value => dispatch(set2FaToken(value)),
  validate2Fa: (params, history) => dispatch(validate2Fa(params, history)),
  resend2FaCode: values => dispatch(resend2FaCode(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Two_FA)
